import fromPairs from 'lodash/fromPairs';
import isArray from 'lodash/isArray';
import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import {
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  INDEX_BY_CLIP_SLUG,
  INDEX_BY_SCENE_ID,
  INDEX_BY_SCENE_SLUG,
  LOAD_CLIPS,
} from '../constants';
import config from '../config';

const defaultState = {
  clips: EMPTY_OBJECT,
  indexByClipSlug: EMPTY_OBJECT,
  indexBySceneId: EMPTY_OBJECT,
  indexBySceneSlug: EMPTY_OBJECT,
};

const remapPairs = [];
if (config.search.staticAssetRemapping !== undefined) {
  remapPairs.splice(
    0,
    0,
    ...config.search.staticAssetRemapping
      .split('||')
      .map(pair => pair.split('|')),
  );
}

const remapAttrs = [
  'clip_lqip',
  'clip_thumbnail',
  'clip_poster',
  'clip_preview_small',
  'clip_preview_large',
  'clip_sequence',
  'scene_lqip',
  'scene_thumbnail',
  'scene_poster',
];

export default function(state = defaultState, action) {
  switch (action.type) {
    case INDEX_BY_CLIP_SLUG:
      return mergeIndex(state, 'indexByClipSlug', action.payload);
    case INDEX_BY_SCENE_ID:
      return mergeIndex(state, 'indexBySceneId', action.payload);
    case INDEX_BY_SCENE_SLUG:
      return mergeIndex(state, 'indexBySceneSlug', action.payload);
    case LOAD_CLIPS: {
      const newClips = action.payload.map(clip => {
        // If we've already processed and stored this clip, skip it.
        if (state.clips[clip.fields.clip_id] !== undefined) {
          return;
        }

        const { _score, ...fields } = clip.fields;
        fields.tags = parseTags(fields.tags);
        fields.clip_length = parseClipLength(fields.clip_length);
        fields.clip_colors = parseColors(fields.clip_colors);
        fields.scene_colors = parseColors(fields.scene_colors);
        fields.scene_clip_count = parseNumber(fields.scene_clip_count);
        return { ...fields, ...remapStaticAssetPaths(fields) };
      });

      const filteredClips = newClips.filter(Boolean);
      if (filteredClips.length === 0) {
        return state;
      }

      const keyedClips = keyBy(filteredClips, 'clip_id');

      return {
        ...state,
        clips: {
          ...state.clips,
          ...keyedClips,
        },
      };
    }
    default:
      return state;
  }
}

// Private funcitons

function parseColors(colors) {
  if (colors === undefined) {
    return EMPTY_ARRAY;
  }
  return fromPairs(colors.map(color => color.split(':')));
}

function parseTags(tags) {
  if (tags === undefined) {
    return EMPTY_ARRAY;
  }

  return tags.map(Number);
}

function parseClipLength(length) {
  try {
    return Number(length);
  } catch (err) {
    console.warn(err);
    return 0;
  }
}

function parseNumber(input) {
  try {
    return Number(input);
  } catch (err) {
    console.warn(err);
    return input;
  }
}

function mergeIndex(state, indexKey, payload) {
  if (state[indexKey][payload.key] !== undefined) {
    return state;
  }

  return {
    ...state,
    [indexKey]: {
      ...state[indexKey],
      [payload.key]: payload.value,
    },
  };
}

function remapStaticAssetPaths(clip) {
  if (remapPairs.length < 1) {
    return EMPTY_OBJECT;
  }

  let remappedPairs = remapAttrs.map(attr => {
    let value = clip[attr];
    if (value === undefined) {
      return;
    }

    return [attr, remapPath(value)];
  });

  remappedPairs = remappedPairs.filter(Boolean);

  return fromPairs(remappedPairs);
}

function remapPath(item) {
  if (isArray(item)) {
    return item.map(remapPath);
  }

  return remapPairs.reduce((acc, next) => {
    const [from, to] = next;
    return acc.replace(from, to);
  }, item);
}



// WEBPACK FOOTER //
// ./src/reducers/clips.js